import { Chip, Typography } from '@packages/shared';

export type BadgeDVProps = {
  text: string;
};

export const BadgeDV = ({ text }: BadgeDVProps) => (
  <Chip
    label={
      <Typography variant="body3" color="text.dark" sx={{ textTransform: 'uppercase' }}>
        {text}
      </Typography>
    }
    color="success"
    sx={{
      height: 'auto',
      backgroundColor: 'success.light',
      border: '1px solid',
      borderColor: 'success.main',
    }}
  />
);
